module.exports = __webpack_public_path__ + "img/module2-03.7ffff4c0.jpg";